export default __webpack_public_path__ + "static/media/brand.72edb3e8.jpg";